import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { modal } from 'react-redux-modal';
import { connect } from 'react-redux';
import validate from './validate';
import { UploadAvatarModal } from '../../';
import { renderField, renderCheckbox } from '../../../utils/renderFields';
import { postSignup } from '../../../actions/auth';
import './styles.scss';
import { saveUserAvatar } from '../../../actions/currentUser';
import TrackedButton from '../../Buttons/TrackedButton';
import { Link } from 'react-router';

const propTypes = {
  countries: PropTypes.array,
  removeModal: PropTypes.func
};

const defaultProps = {

};

class SignUpForm extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.successfulSubmit = this.successfulSubmit.bind(this);
  }

  successfulSubmit() {
    this.props.removeModal();
    modal.add(UploadAvatarModal, {
      title: '',
      size: 'medium',
      hideTitleBar: true,
      registrationSuccess: true,
      afterAcceptCallback: (avatar) => this.props.dispatch(saveUserAvatar(avatar)),
    });
  }

  submit(values) {
    return this.props.dispatch(postSignup(values, this.successfulSubmit));
  }

  render() {
    const { handleSubmit, errors, error, reset, pristine, submitting } = this.props;

    const termsHTML = (<span>I agree to the <Link to="/terms-of-service" className="parent-link">Terms of Use</Link>, <Link
      to="/privacy-policy" className="parent-link">Privacy Policy</Link>, and <Link
      to="/community-guidelines" className="parent-link">Community Guidelines</Link></span>);

    const consentHtml = (<span className="d-block mt-1">I consent to email analytics tracking</span>);

    return (
      <form className="pb-20 signup-email-form" onSubmit={handleSubmit(this.submit)}>
        <span className={error ? 'has-danger pl-10' : ''}>
          <span className="u-fontSize-11 form-control-feedback">{error}</span>
        </span>
        <div className="row no-gutters">
          <div className="col-sm-6">
        <Field name="email" type="email" component={renderField} groupClass="row" className="form-control u-textSize-18"
                label="Email" hiddenLabel/>
          </div>
          <div className="col-sm-6">
        <Field name="username" className="form-control u-textSize-18" type="input" component={renderField}
               label="username" hiddenLabel />
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-sm-6">
            <Field name="password" className="form-control u-textSize-18" type="password" component={renderField} label="password" hiddenLabel />
          </div>
          <div className="col-sm-6">
            <Field name="password_confirm" type="password" component={renderField} className="form-control u-textSize-18"
                   label="confirm password" hiddenLabel />
          </div>
        </div>

        <div className="row no-gutters">
          <div className="col-sm-6 terms-block">
            <Field name="terms" type="checkbox" component={renderCheckbox} className="form-check-input" labelHTML={termsHTML}/>
            <div className="explore-info-text text-center u-textSize-18">Explore never shares information.</div>
          </div>
          <div className="col-sm-6 terms-block">
            <div style={{ paddingBottom: '20px' }}>
            <Field name="newsletter" component={renderCheckbox} className="form-check-input"
                   label="Sign me up for the newsletter"/>
              <Field name="tracking_consent" component={renderCheckbox} className="form-check-input"
                     labelHTML={consentHtml} labelClassName="u-textSize-12" />
            </div>
            <TrackedButton
              buttonType="submit"
              disabled={pristine || submitting}
              className="btn btn-primary"
              title="Sign Up"
              action="Click on Sign Up in Join Module"
              gaAction="Click on 'Sign Up' in Join Module"
              value={100}
            />
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    removeModal: ownProps.removeModal,
  }
};

SignUpForm = reduxForm({
  form: 'signup',
  validate,
  fields: ['password', 'password_confirm', 'username', 'country', 'terms', 'email'],
})(SignUpForm);

SignUpForm.propTypes = propTypes;
SignUpForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(SignUpForm);
